/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef2302d3e60545ba54818efd29a896a6>>
 * @codegenCommand yarn build tokens
 */
const tokens = [
  {
    "value": "#EFFFD6",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#EFFFD6",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime100",
    "path": [
      "color",
      "palette",
      "Lime100"
    ]
  },
  {
    "value": "#D3F1A7",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#D3F1A7",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime200",
    "path": [
      "color",
      "palette",
      "Lime200"
    ]
  },
  {
    "value": "#B3DF72",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#B3DF72",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime300",
    "path": [
      "color",
      "palette",
      "Lime300"
    ]
  },
  {
    "value": "#94C748",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#94C748",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime400",
    "path": [
      "color",
      "palette",
      "Lime400"
    ]
  },
  {
    "value": "#82B536",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#82B536",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime500",
    "path": [
      "color",
      "palette",
      "Lime500"
    ]
  },
  {
    "value": "#6A9A23",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#6A9A23",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime600",
    "path": [
      "color",
      "palette",
      "Lime600"
    ]
  },
  {
    "value": "#5B7F24",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#5B7F24",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime700",
    "path": [
      "color",
      "palette",
      "Lime700"
    ]
  },
  {
    "value": "#4C6B1F",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#4C6B1F",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime800",
    "path": [
      "color",
      "palette",
      "Lime800"
    ]
  },
  {
    "value": "#37471F",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#37471F",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime900",
    "path": [
      "color",
      "palette",
      "Lime900"
    ]
  },
  {
    "value": "#28311B",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#28311B",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime1000",
    "path": [
      "color",
      "palette",
      "Lime1000"
    ]
  },
  {
    "value": "#FFECEB",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFECEB",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red100",
    "path": [
      "color",
      "palette",
      "Red100"
    ]
  },
  {
    "value": "#FFD5D2",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFD5D2",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red200",
    "path": [
      "color",
      "palette",
      "Red200"
    ]
  },
  {
    "value": "#FD9891",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FD9891",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red300",
    "path": [
      "color",
      "palette",
      "Red300"
    ]
  },
  {
    "value": "#F87168",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F87168",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red400",
    "path": [
      "color",
      "palette",
      "Red400"
    ]
  },
  {
    "value": "#F15B50",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F15B50",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red500",
    "path": [
      "color",
      "palette",
      "Red500"
    ]
  },
  {
    "value": "#E2483D",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E2483D",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red600",
    "path": [
      "color",
      "palette",
      "Red600"
    ]
  },
  {
    "value": "#C9372C",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#C9372C",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red700",
    "path": [
      "color",
      "palette",
      "Red700"
    ]
  },
  {
    "value": "#AE2E24",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#AE2E24",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red800",
    "path": [
      "color",
      "palette",
      "Red800"
    ]
  },
  {
    "value": "#5D1F1A",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#5D1F1A",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red900",
    "path": [
      "color",
      "palette",
      "Red900"
    ]
  },
  {
    "value": "#42221F",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#42221F",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red1000",
    "path": [
      "color",
      "palette",
      "Red1000"
    ]
  },
  {
    "value": "#FFF3EB",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFF3EB",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange100",
    "path": [
      "color",
      "palette",
      "Orange100"
    ]
  },
  {
    "value": "#FEDEC8",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FEDEC8",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange200",
    "path": [
      "color",
      "palette",
      "Orange200"
    ]
  },
  {
    "value": "#FEC195",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FEC195",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange300",
    "path": [
      "color",
      "palette",
      "Orange300"
    ]
  },
  {
    "value": "#FEA362",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FEA362",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange400",
    "path": [
      "color",
      "palette",
      "Orange400"
    ]
  },
  {
    "value": "#F38A3F",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F38A3F",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange500",
    "path": [
      "color",
      "palette",
      "Orange500"
    ]
  },
  {
    "value": "#E56910",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E56910",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange600",
    "path": [
      "color",
      "palette",
      "Orange600"
    ]
  },
  {
    "value": "#C25100",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#C25100",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange700",
    "path": [
      "color",
      "palette",
      "Orange700"
    ]
  },
  {
    "value": "#A54800",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#A54800",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange800",
    "path": [
      "color",
      "palette",
      "Orange800"
    ]
  },
  {
    "value": "#702E00",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#702E00",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange900",
    "path": [
      "color",
      "palette",
      "Orange900"
    ]
  },
  {
    "value": "#38291E",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#38291E",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange1000",
    "path": [
      "color",
      "palette",
      "Orange1000"
    ]
  },
  {
    "value": "#FFF7D6",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFF7D6",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow100",
    "path": [
      "color",
      "palette",
      "Yellow100"
    ]
  },
  {
    "value": "#F8E6A0",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F8E6A0",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow200",
    "path": [
      "color",
      "palette",
      "Yellow200"
    ]
  },
  {
    "value": "#F5CD47",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F5CD47",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow300",
    "path": [
      "color",
      "palette",
      "Yellow300"
    ]
  },
  {
    "value": "#E2B203",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E2B203",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow400",
    "path": [
      "color",
      "palette",
      "Yellow400"
    ]
  },
  {
    "value": "#CF9F02",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#CF9F02",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow500",
    "path": [
      "color",
      "palette",
      "Yellow500"
    ]
  },
  {
    "value": "#B38600",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#B38600",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow600",
    "path": [
      "color",
      "palette",
      "Yellow600"
    ]
  },
  {
    "value": "#946F00",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#946F00",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow700",
    "path": [
      "color",
      "palette",
      "Yellow700"
    ]
  },
  {
    "value": "#7F5F01",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#7F5F01",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow800",
    "path": [
      "color",
      "palette",
      "Yellow800"
    ]
  },
  {
    "value": "#533F04",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#533F04",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow900",
    "path": [
      "color",
      "palette",
      "Yellow900"
    ]
  },
  {
    "value": "#332E1B",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#332E1B",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow1000",
    "path": [
      "color",
      "palette",
      "Yellow1000"
    ]
  },
  {
    "value": "#DCFFF1",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#DCFFF1",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green100",
    "path": [
      "color",
      "palette",
      "Green100"
    ]
  },
  {
    "value": "#BAF3DB",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#BAF3DB",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green200",
    "path": [
      "color",
      "palette",
      "Green200"
    ]
  },
  {
    "value": "#7EE2B8",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#7EE2B8",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green300",
    "path": [
      "color",
      "palette",
      "Green300"
    ]
  },
  {
    "value": "#4BCE97",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#4BCE97",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green400",
    "path": [
      "color",
      "palette",
      "Green400"
    ]
  },
  {
    "value": "#2ABB7F",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#2ABB7F",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green500",
    "path": [
      "color",
      "palette",
      "Green500"
    ]
  },
  {
    "value": "#22A06B",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#22A06B",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green600",
    "path": [
      "color",
      "palette",
      "Green600"
    ]
  },
  {
    "value": "#1F845A",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1F845A",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green700",
    "path": [
      "color",
      "palette",
      "Green700"
    ]
  },
  {
    "value": "#216E4E",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#216E4E",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green800",
    "path": [
      "color",
      "palette",
      "Green800"
    ]
  },
  {
    "value": "#164B35",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#164B35",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green900",
    "path": [
      "color",
      "palette",
      "Green900"
    ]
  },
  {
    "value": "#1C3329",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1C3329",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green1000",
    "path": [
      "color",
      "palette",
      "Green1000"
    ]
  },
  {
    "value": "#E7F9FF",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E7F9FF",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal100",
    "path": [
      "color",
      "palette",
      "Teal100"
    ]
  },
  {
    "value": "#C6EDFB",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#C6EDFB",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal200",
    "path": [
      "color",
      "palette",
      "Teal200"
    ]
  },
  {
    "value": "#9DD9EE",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#9DD9EE",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal300",
    "path": [
      "color",
      "palette",
      "Teal300"
    ]
  },
  {
    "value": "#6CC3E0",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#6CC3E0",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal400",
    "path": [
      "color",
      "palette",
      "Teal400"
    ]
  },
  {
    "value": "#42B2D7",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#42B2D7",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal500",
    "path": [
      "color",
      "palette",
      "Teal500"
    ]
  },
  {
    "value": "#2898BD",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#2898BD",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal600",
    "path": [
      "color",
      "palette",
      "Teal600"
    ]
  },
  {
    "value": "#227D9B",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#227D9B",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal700",
    "path": [
      "color",
      "palette",
      "Teal700"
    ]
  },
  {
    "value": "#206A83",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#206A83",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal800",
    "path": [
      "color",
      "palette",
      "Teal800"
    ]
  },
  {
    "value": "#164555",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#164555",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal900",
    "path": [
      "color",
      "palette",
      "Teal900"
    ]
  },
  {
    "value": "#1E3137",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1E3137",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal1000",
    "path": [
      "color",
      "palette",
      "Teal1000"
    ]
  },
  {
    "value": "#E9F2FF",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E9F2FF",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue100",
    "path": [
      "color",
      "palette",
      "Blue100"
    ]
  },
  {
    "value": "#CCE0FF",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#CCE0FF",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue200",
    "path": [
      "color",
      "palette",
      "Blue200"
    ]
  },
  {
    "value": "#85B8FF",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#85B8FF",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue300",
    "path": [
      "color",
      "palette",
      "Blue300"
    ]
  },
  {
    "value": "#579DFF",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#579DFF",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue400",
    "path": [
      "color",
      "palette",
      "Blue400"
    ]
  },
  {
    "value": "#388BFF",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#388BFF",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue500",
    "path": [
      "color",
      "palette",
      "Blue500"
    ]
  },
  {
    "value": "#1D7AFC",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1D7AFC",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue600",
    "path": [
      "color",
      "palette",
      "Blue600"
    ]
  },
  {
    "value": "#0C66E4",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#0C66E4",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue700",
    "path": [
      "color",
      "palette",
      "Blue700"
    ]
  },
  {
    "value": "#0055CC",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#0055CC",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue800",
    "path": [
      "color",
      "palette",
      "Blue800"
    ]
  },
  {
    "value": "#09326C",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#09326C",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue900",
    "path": [
      "color",
      "palette",
      "Blue900"
    ]
  },
  {
    "value": "#1C2B41",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1C2B41",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue1000",
    "path": [
      "color",
      "palette",
      "Blue1000"
    ]
  },
  {
    "value": "#F3F0FF",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F3F0FF",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple100",
    "path": [
      "color",
      "palette",
      "Purple100"
    ]
  },
  {
    "value": "#DFD8FD",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#DFD8FD",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple200",
    "path": [
      "color",
      "palette",
      "Purple200"
    ]
  },
  {
    "value": "#B8ACF6",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#B8ACF6",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple300",
    "path": [
      "color",
      "palette",
      "Purple300"
    ]
  },
  {
    "value": "#9F8FEF",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#9F8FEF",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple400",
    "path": [
      "color",
      "palette",
      "Purple400"
    ]
  },
  {
    "value": "#8F7EE7",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#8F7EE7",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple500",
    "path": [
      "color",
      "palette",
      "Purple500"
    ]
  },
  {
    "value": "#8270DB",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#8270DB",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple600",
    "path": [
      "color",
      "palette",
      "Purple600"
    ]
  },
  {
    "value": "#6E5DC6",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#6E5DC6",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple700",
    "path": [
      "color",
      "palette",
      "Purple700"
    ]
  },
  {
    "value": "#5E4DB2",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#5E4DB2",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple800",
    "path": [
      "color",
      "palette",
      "Purple800"
    ]
  },
  {
    "value": "#352C63",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#352C63",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple900",
    "path": [
      "color",
      "palette",
      "Purple900"
    ]
  },
  {
    "value": "#2B273F",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#2B273F",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple1000",
    "path": [
      "color",
      "palette",
      "Purple1000"
    ]
  },
  {
    "value": "#FFECF8",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFECF8",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta100",
    "path": [
      "color",
      "palette",
      "Magenta100"
    ]
  },
  {
    "value": "#FDD0EC",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FDD0EC",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta200",
    "path": [
      "color",
      "palette",
      "Magenta200"
    ]
  },
  {
    "value": "#F797D2",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F797D2",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta300",
    "path": [
      "color",
      "palette",
      "Magenta300"
    ]
  },
  {
    "value": "#E774BB",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E774BB",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta400",
    "path": [
      "color",
      "palette",
      "Magenta400"
    ]
  },
  {
    "value": "#DA62AC",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#DA62AC",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta500",
    "path": [
      "color",
      "palette",
      "Magenta500"
    ]
  },
  {
    "value": "#CD519D",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#CD519D",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta600",
    "path": [
      "color",
      "palette",
      "Magenta600"
    ]
  },
  {
    "value": "#AE4787",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#AE4787",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta700",
    "path": [
      "color",
      "palette",
      "Magenta700"
    ]
  },
  {
    "value": "#943D73",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#943D73",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta800",
    "path": [
      "color",
      "palette",
      "Magenta800"
    ]
  },
  {
    "value": "#50253F",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#50253F",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta900",
    "path": [
      "color",
      "palette",
      "Magenta900"
    ]
  },
  {
    "value": "#3D2232",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#3D2232",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta1000",
    "path": [
      "color",
      "palette",
      "Magenta1000"
    ]
  },
  {
    "value": "#FFFFFF",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFFFFF",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral0",
    "path": [
      "color",
      "palette",
      "Neutral0"
    ]
  },
  {
    "value": "#F7F8F9",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F7F8F9",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral100",
    "path": [
      "color",
      "palette",
      "Neutral100"
    ]
  },
  {
    "value": "#F1F2F4",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F1F2F4",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral200",
    "path": [
      "color",
      "palette",
      "Neutral200"
    ]
  },
  {
    "value": "#DCDFE4",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#DCDFE4",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral300",
    "path": [
      "color",
      "palette",
      "Neutral300"
    ]
  },
  {
    "value": "#B3B9C4",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#B3B9C4",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral400",
    "path": [
      "color",
      "palette",
      "Neutral400"
    ]
  },
  {
    "value": "#8590A2",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#8590A2",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral500",
    "path": [
      "color",
      "palette",
      "Neutral500"
    ]
  },
  {
    "value": "#758195",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#758195",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral600",
    "path": [
      "color",
      "palette",
      "Neutral600"
    ]
  },
  {
    "value": "#626F86",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#626F86",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral700",
    "path": [
      "color",
      "palette",
      "Neutral700"
    ]
  },
  {
    "value": "#44546F",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#44546F",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral800",
    "path": [
      "color",
      "palette",
      "Neutral800"
    ]
  },
  {
    "value": "#2C3E5D",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#2C3E5D",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral900",
    "path": [
      "color",
      "palette",
      "Neutral900"
    ]
  },
  {
    "value": "#172B4D",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#172B4D",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral1000",
    "path": [
      "color",
      "palette",
      "Neutral1000"
    ]
  },
  {
    "value": "#091E42",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#091E42",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral1100",
    "path": [
      "color",
      "palette",
      "Neutral1100"
    ]
  },
  {
    "value": "#091E4208",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#091E4208",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral100A",
    "path": [
      "color",
      "palette",
      "Neutral100A"
    ]
  },
  {
    "value": "#091E420F",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#091E420F",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral200A",
    "path": [
      "color",
      "palette",
      "Neutral200A"
    ]
  },
  {
    "value": "#091E4224",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#091E4224",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral300A",
    "path": [
      "color",
      "palette",
      "Neutral300A"
    ]
  },
  {
    "value": "#091E424F",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#091E424F",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral400A",
    "path": [
      "color",
      "palette",
      "Neutral400A"
    ]
  },
  {
    "value": "#091E427D",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#091E427D",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral500A",
    "path": [
      "color",
      "palette",
      "Neutral500A"
    ]
  },
  {
    "value": "#101214",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#101214",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral-100",
    "path": [
      "color",
      "palette",
      "DarkNeutral-100"
    ]
  },
  {
    "value": "#161A1D",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#161A1D",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral0",
    "path": [
      "color",
      "palette",
      "DarkNeutral0"
    ]
  },
  {
    "value": "#1D2125",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1D2125",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral100",
    "path": [
      "color",
      "palette",
      "DarkNeutral100"
    ]
  },
  {
    "value": "#22272B",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#22272B",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral200",
    "path": [
      "color",
      "palette",
      "DarkNeutral200"
    ]
  },
  {
    "value": "#282E33",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#282E33",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral250",
    "path": [
      "color",
      "palette",
      "DarkNeutral250"
    ]
  },
  {
    "value": "#2C333A",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#2C333A",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral300",
    "path": [
      "color",
      "palette",
      "DarkNeutral300"
    ]
  },
  {
    "value": "#38414A",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#38414A",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral350",
    "path": [
      "color",
      "palette",
      "DarkNeutral350"
    ]
  },
  {
    "value": "#454F59",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#454F59",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral400",
    "path": [
      "color",
      "palette",
      "DarkNeutral400"
    ]
  },
  {
    "value": "#596773",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#596773",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral500",
    "path": [
      "color",
      "palette",
      "DarkNeutral500"
    ]
  },
  {
    "value": "#738496",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#738496",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral600",
    "path": [
      "color",
      "palette",
      "DarkNeutral600"
    ]
  },
  {
    "value": "#8C9BAB",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#8C9BAB",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral700",
    "path": [
      "color",
      "palette",
      "DarkNeutral700"
    ]
  },
  {
    "value": "#9FADBC",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#9FADBC",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral800",
    "path": [
      "color",
      "palette",
      "DarkNeutral800"
    ]
  },
  {
    "value": "#B6C2CF",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#B6C2CF",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral900",
    "path": [
      "color",
      "palette",
      "DarkNeutral900"
    ]
  },
  {
    "value": "#C7D1DB",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#C7D1DB",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral1000",
    "path": [
      "color",
      "palette",
      "DarkNeutral1000"
    ]
  },
  {
    "value": "#DEE4EA",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#DEE4EA",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral1100",
    "path": [
      "color",
      "palette",
      "DarkNeutral1100"
    ]
  },
  {
    "value": "#03040442",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#03040442",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral-100A",
    "path": [
      "color",
      "palette",
      "DarkNeutral-100A"
    ]
  },
  {
    "value": "#BCD6F00A",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#BCD6F00A",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral100A",
    "path": [
      "color",
      "palette",
      "DarkNeutral100A"
    ]
  },
  {
    "value": "#A1BDD914",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#A1BDD914",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral200A",
    "path": [
      "color",
      "palette",
      "DarkNeutral200A"
    ]
  },
  {
    "value": "#C8E1F91A",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#C8E1F91A",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral250A",
    "path": [
      "color",
      "palette",
      "DarkNeutral250A"
    ]
  },
  {
    "value": "#A6C5E229",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#A6C5E229",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral300A",
    "path": [
      "color",
      "palette",
      "DarkNeutral300A"
    ]
  },
  {
    "value": "#C3DEFE33",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#C3DEFE33",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral350A",
    "path": [
      "color",
      "palette",
      "DarkNeutral350A"
    ]
  },
  {
    "value": "#BFDBF847",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#BFDBF847",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral400A",
    "path": [
      "color",
      "palette",
      "DarkNeutral400A"
    ]
  },
  {
    "value": "#9BB4CA80",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#9BB4CA80",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral500A",
    "path": [
      "color",
      "palette",
      "DarkNeutral500A"
    ]
  },
  {
    "value": 0.2,
    "attributes": {
      "group": "palette",
      "category": "opacity"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": 0.2,
      "attributes": {
        "group": "palette",
        "category": "opacity"
      }
    },
    "name": "value.opacity.Opacity20",
    "path": [
      "value",
      "opacity",
      "Opacity20"
    ]
  },
  {
    "value": 0.4,
    "attributes": {
      "group": "palette",
      "category": "opacity"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": 0.4,
      "attributes": {
        "group": "palette",
        "category": "opacity"
      }
    },
    "name": "value.opacity.Opacity40",
    "path": [
      "value",
      "opacity",
      "Opacity40"
    ]
  }
];

export default tokens;
